export default __webpack_public_path__ + "static/media/team30.e9b9a242.JPG";